module.exports = __webpack_public_path__ + "media/images/front/spacer-325472601571f31e1bf00674c368d335.gif";